define("shared/components/shared/addon-details-card/current-plan", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAC--addonCard">
    <div>
      <div>
        {{@title}}
        {{#if @toggleModal}}
          <Shared::Ui::Button @variant="unstyled" {{on "click" @toggleModal}}>
            {{svg-jar "info" class="o--icon u--cursor"}}
          </Shared::Ui::Button>
        {{/if}}
      </div>
      {{#if @description}}
        <span class="u--text--base">
          {{@description}}
        </span>
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "cI682Cw0",
    "block": "[[[10,0],[14,0,\"tAC--addonCard\"],[12],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[10,0],[12],[1,\"\\n      \"],[1,[30,1]],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[8,[39,1],[[4,[38,2],[\"click\",[30,2]],null]],[[\"@variant\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon u--cursor\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[10,1],[14,0,\"u--text--base\"],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@title\",\"@toggleModal\",\"@description\"],false,[\"if\",\"shared/ui/button\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/addon-details-card/current-plan.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});